import React, { useMemo } from "react";
import SpreadSheetTable from "./components/SpreadSheetTable";

export default function ECLSpreadSheetBlock(props) {
   const spreadsheet = useMemo(() => {
      if (props.block.data.columns.length < 1) {
         return (
            <>
               <label htmlFor="empty-spreadsheet-relation">
                  {props.block.data.name}
               </label>
               <p id="empty-spreadsheet-relation">No Spreadsheet Data</p>
            </>
         );
      }
      return (
         <section id="spreadsheet-block" className="spreadsheet-block">
            <h2>{props.block.data.name}</h2>
            <SpreadSheetTable endpoint={"AllData"} {...props} />
         </section>
      );
   }, [props.block]);
   return spreadsheet;
}
